export const formatDate = date => {
  if (date && !isNaN(date?.getTime())) {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
  }
}

export const getInitialDates = rangeValue => {
  const startDate = new Date(rangeValue?.startDate)
  const endDate = new Date(rangeValue?.endDate)

  return {
    startDate: isNaN(startDate.getTime()) ? null : startDate,
    endDate: isNaN(endDate.getTime()) ? null : endDate,
  }
}

export const isCustomDateRangeValid = (startDate, endDate) => {
  const regex = /^\d{1,2}\/\d{1,2}\/\d{4}$/
  return regex.test(startDate) && regex.test(endDate)
}
